import {
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewChild,
    TemplateRef
} from '@angular/core';
import {ComRestrictionsGridLayoutService} from '@irb/irb-editors/editor-portfolio/com-restrictions/com-restrictions.grid-layout.service';
import {
    IAssetCustomCategories,
    IAssetCustomCategory,
    ICustomSecurity,
    IPortfolioRestrictions,
    ISecurities,
    IPortfolioDetail
} from '@irb/irb-editors/irb-editors.model';
import {CalltoactionService} from '@irb/irb-common/components/calltoaction/calltoaction.service';
import {IrbEditorsService} from '@irb/irb-editors/irb-editors.service';
import {UtilityService} from "@irb-common/services/utility.service";
import {IEvent, IEventSubscriber, IrbEditorsEvents, IrbModelsEvents, IrbSettingsEvents} from '@irb/irb-common/events';
import {ReplaySubject, Subscription} from 'rxjs';
import {AppService} from '@irb/app.service';
import {takeUntil} from 'rxjs/operators';
import {IDropdownItem} from '@irb-common/models/dropdown.model';
import {DropdownSearchMultipleComponent} from "@irb-common/components/dropdown-search-multiple/dropdown-search-multiple.component";
import {DropdownFilterComponent} from "@irb-common/components/dropdown-filter/dropdown-filter.component";
import { IGlobalSettings } from "@irb/irb-settings/irb-settings.model";

@Component({
  selector: 'irb-com-gains',
  templateUrl: './com-gains.component.html',
  styleUrl: './com-gains.component.scss',
    standalone: false
})
export class ComGainsComponent {
@ViewChild('comRestrictionsDeleteOverlay') comRestrictionsDeleteOverlay: TemplateRef<any>;
    @ViewChild('gainsControlSetting') gainsControlSetting: DropdownFilterComponent;
    @ViewChild('gainsThresholdType') gainsThresholdType: DropdownFilterComponent;
    @ViewChild('gainsThresholdAmtInput') gainsThresholdAmtInput: any;

    @Input() multipleporfolios: boolean = false;
    @Input() data: IPortfolioDetail;
    @Input() globalSettings: IGlobalSettings;
    @Input() isValid: boolean;
    @Output() isValidChange = new EventEmitter<boolean>();
    @Output() change = new EventEmitter<any>();

    private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
    eventSubscription: Subscription;
    gainsRestrictionDropdownItem: IDropdownItem;
    gainsThresholdTypeDropdownItem: IDropdownItem;
    gainsThresholdAmt: number = 0;
    isUiTest = false;
    isEditGainThresholdFeatureFlagEnabled: boolean = false;
    
    gainsRestrictionsTypeList: Array<IDropdownItem> = [
        {name: "No restrictions", value:"No restrictions"},
        {name: "Avoid short-term gains", value:"Avoid short-term gains"},
        {name: "Avoid all gains", value:"Avoid all gains"}
    ]

    gainsThresholdTypeList: Array<IDropdownItem> = [
        {name: "No Threshold", value:"NO_THRESHOLD"},
        {name: "Use Global Default", value:"USE_GLOBAL_DEFAULT"},
        {name: "Set Custom", value:"SET_CUSTOM"}
    ];

    ngOnInit(): void {
        this.eventSubscription = this.as.getEvents().pipe(takeUntil(this.destroyed$)).subscribe((s) => {
            this.processEvent(s);
        });

        this.load();
    }

    setPortfolioCapitalGains(searchStr: any) {
        this.gainsControlSetting.set(DropdownFilterComponent.getFilteredList(searchStr, this.gainsRestrictionsTypeList));
    }

    setGainsThresholdTypes(searchStr: any) {
        this.gainsThresholdType.set(DropdownFilterComponent.getFilteredList(searchStr, this.gainsThresholdTypeList));
    }

    processEvent(event: IEvent) {
        switch (event.type) {
        }
    }

    ngOnDestroy() {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }

    constructor(
        public ies: IrbEditorsService,
        private util: UtilityService,
        private as: AppService
    ) {
        this.isEditGainThresholdFeatureFlagEnabled = this.as.getItem('IRB_APP_CONFIG')?.featureFlags.ENABLE_GAINS_THRESHOLD || false;
    }

    load() {        
        this.gainsRestrictionDropdownItem = this.gainsRestrictionsTypeList.find((x: IDropdownItem) => x.value == this.data?.gainsControlSetting);
        this.gainsThresholdTypeDropdownItem = this.gainsThresholdTypeList.find((x: IDropdownItem) => x.value == this.data?.gainsThresholdType);
    }

    onGainsRestrictionChange() {
        this.data.gainsControlSetting = this.gainsRestrictionDropdownItem.value;
        this.validateInput();
    }

    onGainsThresholdTypeChange() {
        if(this.data.gainsThresholdType != this.gainsThresholdTypeDropdownItem.value) {
            this.data.gainsThresholdType = this.gainsThresholdTypeDropdownItem.value;
            this.data.gainsThresholdAmt = 0;
            
            setTimeout(() => {
                this.gainsThresholdAmtInput?.inputControl.markAsTouched();
                this.validateInput();
            });
        }
    }

    onGainsThresholdAmtChange() {
        setTimeout(() => {
            this.gainsThresholdAmtInput?.inputControl.markAsTouched();
            this.validateInput();
        });
    }

    validateInput() {
        this.isValid = true;
        
        if(this.gainsThresholdAmtInput?.inputControl.invalid) {
            this.isValid = false;
        }

        this.isValidChange.emit(this.isValid);
        this.change.emit(true);
    }
}
